<div class="initials is-flex has-flex-content-center has-flex-align-center">{{initials}}</div>
